import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import qParams from '../../routes/queryParamsVariables';
import { useAuthorizationContext } from './AuthorizationContainer';
import useAuthorizationModel from '../../hooks/authorization/useAuthorizationModel';
import navigationsRoute from '../../routes/navigationsRoute';
import utils from 'utils';

/**
 * This component is used to automatically log users in when they complete
 * the email verification step.
 */
function EasyLogin() {
  const params = useParams<{ [key: string]: string }>();
  const history = useHistory();
  const { actions } = useAuthorizationContext();
  const { autoLogin } = useAuthorizationModel();
  const uuid = params[qParams.deviceToken];
  const sessionToken = params[qParams.sessionToken];
  const isNoAuthParams = !uuid || !sessionToken;

  const redirectToLogin = () => {
    history.push(navigationsRoute.LOGIN_PAGE);
  };

  const saveUserData = (response: any) => {
    actions.logout();
    utils.disableAutologinSession();
    utils.setLocalStorage({
      emailAddress: response.baseUserInfo.username,
      sessionToken: response.sessionToken,
      authenticatedData: response,
      uuid,
      rememberMe: true,
    });

    actions.login();
  };

  useEffect(() => {
    if (isNoAuthParams) return redirectToLogin();

    const requestDate = utils.getTimestamp().toString();
    const controller = new AbortController();

    autoLogin({ requestDate, uuid, sessionToken }, controller.signal)
      .then(saveUserData)
      .catch(console.log)
      .finally(redirectToLogin);

    return () => controller.abort('EasyLogin component unmounted');
  }, []);

  // Still waiting for login to finish. Do nothing and wait for re-render.
  return null;
}

export default EasyLogin;
